import { useLocation } from 'react-router-dom';

import { CreatePropertyAdV2 } from '../PropertyAdEditor';
import type { AiListingEditorNavigationState } from '../PropertyAdEditor/aiListingNavigation';
import { Dashboard } from './Dashboard';

export const CreatePropertyAdV2Page = () => {
  const location = useLocation();

  return (
    <Dashboard openLogIn>
      <CreatePropertyAdV2
        aiNavigationState={location.state as AiListingEditorNavigationState | null}
      />
    </Dashboard>
  );
};
